export default {
  methods: {
    showValue(prop) {
      if (Object.keys(this.$route.query).length) {
        let { QUERY_CONDITIONS } = this.$route.query;
        QUERY_CONDITIONS = JSON.parse(QUERY_CONDITIONS);
        if (Array.isArray(prop) && prop.length) {
          return prop.map(e => QUERY_CONDITIONS[e]);
        } else {
          return QUERY_CONDITIONS[prop];
        }
      } else {
        return false;
      }
    }
  }
};
